/**
 * Pagination utilities.
 */

/**
 * Calculate the number of pages needed for pagination.
 * Handles edge cases: zero/negative values, division by zero.
 * Always returns at least 1.
 */
export const calculatePageCount = (total: number, perPage: number): number => {
  if (total <= 0 || perPage <= 0) return 1;
  return Math.ceil(total / perPage);
};
